import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { compose } from '@reduxjs/toolkit';
import { useDispatch, connect } from 'react-redux';

import Pagination from 'core/pagination/Pagination';
import { setAuditLogParam } from 'app/features/roles-and-permissions/roleAndPermissionsSlice';

function AuditLogPagination({ totalCount, pageSize, pageNumber }) {
  const dispatch = useDispatch();

  return (
    <Box component="div" sx={{ py: 2 }}>
      <Pagination
        count={Math.ceil(totalCount / pageSize)}
        page={pageNumber}
        onChange={(currentPage) => dispatch(setAuditLogParam({ page_number: currentPage }))}
        onRowPerPageChange={(rowPerPage) =>
          dispatch(setAuditLogParam({ page_size: rowPerPage, page_number: 1 }))
        }
        perPageValue={pageSize}
      />
    </Box>
  );
}

function mapStateToProps(state) {
  const { auditLogs } = state.rolesAndPermissions;
  return {
    totalCount: auditLogs.pagination?.totalCount ?? 0,
    pageSize: auditLogs.params?.page_size ?? 10,
    pageNumber: auditLogs.params?.page_number ?? 1,
  };
}

export default compose(connect(mapStateToProps))(AuditLogPagination);

AuditLogPagination.propTypes = {
  pageSize: PropTypes.number,
  totalCount: PropTypes.number,
  pageNumber: PropTypes.number,
};